import React from 'react'
import Withdrawal from '@commons/withdraw'

const WithdrawalRequest = () => {
  return <Withdrawal status={'Pending'} />
}

export default WithdrawalRequest
